import { useDocumentFilters } from "../../context/DocumentFiltersContext";
import { DocumentSearchField } from "./DocumentSearchField";

interface DocumentSearchInputProps {
  className?: string;
  /** Overrides the default "Search documents…" placeholder (the Folders tab
   *  searches within the open folder's subtree, so it reads differently). */
  placeholder?: string;
}

/**
 * The documents toolbar search box, bound to the shared DocumentFiltersContext.
 *
 * One box drives every view tab — the List view's server-side name filter, the
 * timeline's content search, and the folder view's subtree search — because it
 * lives in the page-level tools row, outside whichever view is mounted. That is
 * also why it can't watch a fetch directly: the mounted view reports the query
 * it has finished resolving, and the box is busy while that trails the
 * committed one.
 *
 * Interaction (Enter / button / idle, never per-keystroke) lives in
 * DocumentSearchField, which the folder view reuses on /projects where there is
 * no provider.
 */
export function DocumentSearchInput({ className, placeholder }: DocumentSearchInputProps) {
  const { filters, resolvedSearchQuery, setSearchQuery } = useDocumentFilters();

  return (
    <DocumentSearchField
      value={filters.searchQuery}
      onCommit={setSearchQuery}
      isBusy={filters.searchQuery !== resolvedSearchQuery}
      className={className}
      placeholder={placeholder}
    />
  );
}
